import { IPurchaseOrderRepository } from "domain/contracts/purchase-order.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { PurchaseOrder } from "domain/entities/purchase-order";
import { PurchaseOrderInputFilter } from "domain/models/purchase-order-input-filter";
import { formatDate } from "presentation/utils/formatEndDate";

class PurchaseOrderRepository implements IPurchaseOrderRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/purchaseOrder/${id}`);
    return response.data;
  }

  async create(input: PurchaseOrder): Promise<Message<PurchaseOrder>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { 
      ...input, 
      endAt: endAt, 
      startAt: startAt,
      plafound: input.plafond,
      plafoundLeft: input.plafondLeft
    };

    const response = await httpClient.post(`/purchaseOrder`, { data: newInput });
    const mappedData = response.data.data ? {
      ...response.data.data,
      plafond: response.data.data.plafound,
      plafondLeft: response.data.data.plafoundLeft
    } : response.data.data;

    return { ...response.data, data: mappedData };
  }

  async update(input: PurchaseOrder): Promise<Message<boolean>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { 
      ...input, 
      endAt: endAt, 
      startAt: startAt,
      plafound: input.plafond,
      plafoundLeft: input.plafondLeft
    };

    const response = await httpClient.put(`/purchaseOrder/${input.id}`, {
      data: newInput,
    });
    return response.data;
  }

  async updateStatus(
    id: string,
    status: string,
    justification: string
  ): Promise<Message<boolean>> {
    const response = await httpClient.patch(`/purchaseOrder/${id}/status`, {
      data: { status, justification },
    });
    return response.data;
  }

  async getAll(
    filter: PurchaseOrderInputFilter
  ): Promise<Message<PurchaseOrder[]>> {
    const response = await httpClient.get(`/purchaseOrder`, { params: filter });
    const mappedData = response.data.data?.map((po: any) => ({
      ...po,
      plafond: po.plafound,
      plafondLeft: po.plafoundLeft
    })) || [];
    return { ...response.data, data: mappedData };
  }

  async getById(id: string): Promise<Message<PurchaseOrder>> {
    const response = await httpClient.get(`/purchaseOrder/${id}`);
    const mappedData = response.data.data ? {
      ...response.data.data,
      plafond: response.data.data.plafound,
      plafondLeft: response.data.data.plafoundLeft
    } : response.data.data;
    return { ...response.data, data: mappedData };
  }
}

export default new PurchaseOrderRepository();
